<div
  class="container-folder flex flex-col"
  (click)="selectGroup()"
  [class.selected]="currentPrintProduct?.cartId === group.cartId && !isStatic"
  [class.out-of-stock]="cartService.exceededBindingItems(group.product.printingGroup).length > 0 && inCart"
  [ngClass]="{ 'cursor-pointer': !(inCart || isStatic) }"
>
  <div class="flex flex-row items-start justify-between">
    <div>
      <span *ngIf="currentPrintProduct?.cartId === group.cartId && !isStatic" class="edit-folder-message">
        Estás editando esta carpeta
      </span>

      @if (cartService.exceededBindingItems(group.product.printingGroup).length && inCart) {
        <ion-icon
          #outOfStockIcon
          class="out-of-stock-icon"
          src="../../../../assets/icon/alert.svg"
          (click)="openOutOfStockPopover($event)"
        ></ion-icon>
      }
    </div>

    @if (!isStatic) {
      <ion-button
        #tooltip="tooltip"
        tooltip="Más acciones"
        tooltipClass="no-transition"
        [hideDelay]="0"
        class="popover-button"
        slot="only-icon"
        fill="clear"
        color="dark"
        (click)="openPopover($event, popover)"
      >
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>
    }

    <ion-popover #popover side="left" dismissOnSelect="true">
      <ng-template>
        <app-folder-actions-menu
          [inCart]="inCart"
          [item]="group"
          [inOrderDetail]="inOrderDetail"
          [currentPrintProduct]="currentPrintProduct"
        ></app-folder-actions-menu>
      </ng-template>
    </ion-popover>
  </div>

  <div
    class="group-folder"
    [ngClass]="!inCart ? 'cursor-pointer' : ''"
    [class.selected]="currentPrintProduct?.cartId === group.cartId"
  >
    <div class="folder-shape-div"></div>
    <div class="group-name flex flex-row items-center justify-start">
      <!-- <img class="folder-icon" src="assets/icon/folder.svg"> -->
      <span
        class="group-name_abbreviated"
        tooltipClass="white-tooltip"
        #tooltip2="tooltip"
        [tooltip]="group.product.folderName"
        >{{ group.product.folderName }}</span
      >
    </div>
    <div class="group-folder_content flex flex-col justify-between gap-[15px]">
      <app-print-settings-labels
        [printSettings]="group.product.printingGroup.printSettings"
        [files]="group.product.printingGroup.files"
        [size]="'medium'"
      >
      </app-print-settings-labels>

      <div class="flex flex-col gap-2.5">
        <div class="fileCount flex w-full flex-row items-center justify-between">
          <div class="flex flex-row items-center">
            <span
              >{{ group.product.printingGroup.files.length }} archivo{{
                group.product.printingGroup.files.length > 1 ? 's' : ''
              }}</span
            >
          </div>

          <span class="price">{{ group.price.amt | currency: group.price.cur }}</span>
        </div>

        @if (cartService.currentStep < 2 && !isStatic) {
          <div class="qtyCounter flex flex-row items-center justify-between">
            <app-qty-stepper
              [qty]="group.qty"
              [showQty]="true"
              [isFolder]="true"
              (changes)="changeGroupQty($event)"
              [inOrderDetail]="inOrderDetail"
              [min]="1"
              [max]="9999"
            >
            </app-qty-stepper>
          </div>
        }
      </div>
    </div>
  </div>
</div>
